import { render } from "./DxtPackageTopUpLog.vue?vue&type=template&id=6814d66a&scoped=true"
import script from "./DxtPackageTopUpLog.vue?vue&type=script&lang=js"
export * from "./DxtPackageTopUpLog.vue?vue&type=script&lang=js"

import "./DxtPackageTopUpLog.vue?vue&type=style&index=0&id=6814d66a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6814d66a"

export default script